import React, { useState } from 'react';
const IMAGES = ['https://cdn.magicpatterns.com/uploads/oEAFMK42eSCha1JbDjXzPu/image.png'];
/**
 * Product image gallery for the Gen3 E-Foot Gear page.
 * Holds its own thumbnail-selection state — not shared.
 */
export function Gallery() {
  const [activeImage, setActiveImage] = useState(0);
  return <div className="lg:sticky lg:top-32" data-id="element-410">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-10 flex items-center justify-center aspect-square" data-id="element-411">
        <img src={IMAGES[activeImage]} alt="Gen3 E-Foot Gear" className="block max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-105" data-id="element-412" />
      </div>
      {IMAGES.length > 1 && <div className="flex gap-3 mt-4 justify-center lg:justify-start" data-id="element-413">
          {IMAGES.map((src, idx) => <button key={idx} onClick={() => setActiveImage(idx)} className={`w-20 h-20 rounded-xl border-2 p-2 bg-white transition-all ${activeImage === idx ? 'border-red-600 shadow-md' : 'border-gray-200 hover:border-gray-400'}`} aria-label={`View image ${idx + 1}`} data-id="element-414">
              <img src={src} alt={`Thumbnail ${idx + 1}`} className="block w-full h-full object-contain" data-id="element-415" />
            </button>)}
        </div>}
    </div>;
}